import type { TranslationWarningHandler } from '@shared/translation';
import { isDev } from '@/util/env';

export const handleTranslationWarning: TranslationWarningHandler | undefined =
  isDev
    ? (warning) => {
        console.warn('Translation warning', warning);
      }
    : undefined;
